import { createElement as _createElement } from "react";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Chip } from '../../chip';
import { ColorIndicator } from '../../color-indicator';
import { getIcon } from '../../icon';
const MAX_TAGS = 10;
function renderValue(_values, getItemProps, props) {
    const values = (Array.isArray(_values) ? _values : [_values]);
    const tagLimit = props.limitTags ?? MAX_TAGS;
    const showMoreTags = values.length > tagLimit;
    const showMoreTagsLabel = `+${values.length - tagLimit}`;
    return (_jsxs(_Fragment, { children: [values.slice(0, tagLimit).map((value, index) => {
                const chipProps = getItemProps({ index });
                const externalProps = props.getChipProps?.(value) ?? {};
                const { onDelete: chipOnDelete, disabled: _chipDisabled, ...chipRestProps } = chipProps;
                const { onDelete: externalOnDelete, ...externalRestProps } = externalProps;
                const icon = (() => {
                    if (props.getOptionColor) {
                        return (_jsx(ColorIndicator, { color: props.getOptionColor(value) }));
                    }
                    if (props.getOptionIcon) {
                        const { icon, iconProps = {} } = props.getOptionIcon(value);
                        const Icon = getIcon(icon);
                        return _jsx(Icon, { ...iconProps });
                    }
                    return undefined;
                })();
                const resolvedChipProps = {
                    ...chipRestProps,
                    ...externalRestProps,
                    onDelete: externalOnDelete ?? chipOnDelete
                };
                return (_createElement(Chip, { ...resolvedChipProps, key: `tag-${index}`, label: props.getOptionLabel?.(value) ??
                        value, icon: resolvedChipProps.icon ?? icon, sx: {
                        maxWidth: ({ spacing }) => {
                            return `calc(50% - ${spacing(0.5)}) !important`;
                        }
                    } }));
            }), showMoreTags && _jsx(Chip, { label: showMoreTagsLabel })] }));
}
export default { renderValue };
